module.exports = __webpack_public_path__ + "img/4-2.f8a4bbe0.jpg";